var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExtendDeadline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M18.965 18.965c0 .19-.154.345-.344.345H1.034V20h18.621V2.759h-.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M18.276 18.62H.345V6.208h17.93zM9.31 17.242a4.828 4.828 0 1 0 0-9.655 4.828 4.828 0 0 0 0 9.655z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M12.175 9.428a4.138 4.138 0 1 1 0 0zm-.509 1.453a.345.345 0 1 0-.574-.383l-2.525 3.788-1.082-1.082a.345.345 0 1 0-.487.488l1.379 1.38a.345.345 0 0 0 .53-.053l2.76-4.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1adb74",
    d: "M14.828 2.069V1.034a.345.345 0 1 1 .69 0v.345h.689v-.345a1.034 1.034 0 1 0-2.07 0V2.07H12.07V1.034a.345.345 0 1 1 .69 0v.345h.69v-.345a1.035 1.035 0 0 0-2.07 0V2.07H5.862V1.034a.345.345 0 1 1 .69 0v.345h.69v-.345a1.034 1.034 0 1 0-2.07 0V2.07H3.103V1.034a.345.345 0 1 1 .69 0v.345h.69v-.345a1.035 1.035 0 0 0-2.07 0V2.07H.346v3.448h17.93V2.07z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtendDeadline);
export default __webpack_public_path__ + "static/media/icon-extend-deadline.0f0111a7.svg";
export { ForwardRef as ReactComponent };